import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/YinYang.es.js";
const n = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: t }));
n.displayName = "YinYangIcon";
const c = n;
export {
  c as YinYang,
  n as YinYangIcon
};
